import { queryOptions } from "@tanstack/react-query";
import { client, handleClientMethod } from "../client.ts";

export const getHajocaHealth = () => {
  return queryOptions({
    queryKey: ["hajoca", "health"],
    queryFn: async () => {
      return await handleClientMethod(client.GET("/api/hajoca/health"));
    },
  });
};
